import { defineComponent, ref, openBlock, createElementBlock, createBlock, unref, createCommentVNode, resolveDynamicComponent, mergeProps, withCtx, createElementVNode, toDisplayString, createTextVNode } from "vue";
import { CdrLink } from "@rei/cedar";
import LoadingRecommendations from "../LoadingRecommendations/LoadingRecommendations.mjs";
const _hoisted_1 = ["aria-labelledby"];
const _hoisted_2 = ["id"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "RrRecs",
  props: {
    dynamicSizing: {
      type: Boolean,
      default: true
    },
    headerId: {
      default: "rr-recs-header"
    },
    imgSize: {
      default: 134
    },
    maxTiles: {
      default: 6
    },
    message: {
      default: ""
    },
    recs: {
      default: void 0
    },
    recsComponent: {},
    recsId: {
      default: null
    },
    shopAllCatText: {
      default: ""
    },
    shopAllCatUrl: {
      default: ""
    },
    showLoadingRecs: {
      type: Boolean
    }
  },
  emits: ["metricsClick", "recsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const rrRecs = ref(null);
    const handleShopAllClick = () => emit("metricsClick", {
      linkName: "shop all"
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("aside", {
        ref_key: "rrRecs",
        ref: rrRecs,
        "aria-labelledby": _ctx.headerId,
        class: "rr-recs"
      }, [_ctx.showLoadingRecs ? (openBlock(), createBlock(unref(LoadingRecommendations), {
        key: 0,
        cards: _ctx.maxTiles
      }, null, 8, ["cards"])) : createCommentVNode("", true), !_ctx.showLoadingRecs && !!_ctx.recsComponent ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.recsComponent), mergeProps({
        key: 1,
        id: _ctx.recsId,
        "dynamic-sizing": _ctx.dynamicSizing,
        "img-size": _ctx.imgSize,
        "max-tiles": _ctx.maxTiles,
        "slider-with-arrows": true
      }, _ctx.recs, {
        onRecsClick: _cache[0] || (_cache[0] = (data) => _ctx.$emit("recsClick", data))
      }), {
        heading: withCtx(() => [createElementVNode("h2", {
          id: _ctx.headerId,
          class: "rr-recs__header"
        }, toDisplayString(_ctx.message), 9, _hoisted_2)]),
        _: 1
      }, 16, ["id", "dynamic-sizing", "img-size", "max-tiles"])) : createCommentVNode("", true), _ctx.shopAllCatUrl ? (openBlock(), createBlock(unref(CdrLink), {
        key: 2,
        class: "rr-recs__category-link",
        href: _ctx.shopAllCatUrl,
        "data-ui": "shop-all-cat",
        onClick: handleShopAllClick
      }, {
        default: withCtx(() => [createTextVNode(toDisplayString(_ctx.shopAllCatText), 1)]),
        _: 1
      }, 8, ["href"])) : createCommentVNode("", true)], 8, _hoisted_1);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=RrRecs2.mjs.map
